import React, { Component, Fragment } from 'react'
import { FieldsListModel, FieldsListResponseModel, FieldsColumnList, DropdownModel, DataSourceFieldsModel, ReportColumnFieldModel, ReportDataSourceFilterModel } from './models'
import { Columns, FilterModel, ColumnType } from '../../../../shared/filter/models'
import { PostExportModel } from '../../../../shared/export/post.export.model'
import { FieldsService } from './services';
import { HttpResponse } from '../../../../core';
import { FileDownloadService } from '../../../../shared/services/file-download.service';
import { ShowErrorMessage } from '../../../../shared/helpers';
import { Link, NavLink } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import ExportComponent from '../../../../shared/export/ExportComponent';
import { StickyTable, Row, Cell, Wrapper } from 'react-sticky-table';
import { Sorting, PaginationRecordInfo, Pagination } from '../../../../shared';
import { Loader } from '../../../../shared/loaders';
import Filter from '../../../../shared/filter/Filter';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../../../redux/navigation';
import { ButtonType, SourceType } from '../../../../shared/enums';
import { IsAuthorize } from '../../../../shared/authorization/check-access';
import { Role } from '../../../../shared/authorization/enums';


interface IProps {
    current_route: string;
    ChangePage: Function;
    currentPage: number;
    ChangeFilters: Function;
    filters:[];

}
interface IState {
    result: FieldsListResponseModel;
    currentPage: number;
    pageSize: number;
    sortBy: string;
    sortOrder: boolean;
    currentColumn: string;
    pageCount: number;
    totalItems: number;
    Columns: Columns[];
    showExportModal?: boolean;
    filters?: FilterModel[];
    isShowFilter: boolean;
    export?: PostExportModel;
    isLoading: boolean;
    Ids: number[];
    selectedIds: FilterModel;
    isAllChecked: boolean;
    isExporting: boolean;
    isSelectedAll?: boolean;
    encodeToName?: string;
    exportTo?: string;
    columnSeparator?: string;
    isNoHeader?: boolean;
}
export class FieldsList extends Component<IProps, IState> {
    private service: FieldsService;
    private currentColumn: string = '';
    columnList = FieldsColumnList;

    constructor(props: IProps) {
        super(props);
        this.state = {
            isSelectedAll: true,
            isNoHeader: false,
            columnSeparator: ",",
            encodeToName: "utf-8",
            exportTo: "csv",
            result: {
                paging: {
                    current_page: this.props.currentPage,
                    page_count: 0,
                    page_size: 0,
                    total_items: 0
                },
                records: []
            },
            currentPage:this.props.currentPage,
            pageSize: 20,
            sortBy: "id",
            sortOrder: true,
            currentColumn: "",
            pageCount: 0,
            totalItems: 0,
            Columns: [
                { id: 1, displayText: "Id", columnName: "id", value: '', type: ColumnType.Number },
                { id: 2, displayText: "Scope", columnName: "scope_name", value: '', type: ColumnType.String },
                { id: 3, displayText: "Name", columnName: "name", value: '', type: ColumnType.String },
                { id: 4, displayText: "Label", columnName: "label", value: '', type: ColumnType.String },
                { id: 5, displayText: "Type", columnName: "type", value: '', type: ColumnType.FieldType },
                { id: 6, displayText: "Column Type", columnName: "column_type", value: '', type: ColumnType.FieldColumnType },
                { id: 7, displayText: "Options", columnName: "options", value: '', type: ColumnType.Time },
                { id: 8, displayText: "Scaling Factor", columnName: "scaling_factor", value: '', type: ColumnType.Number },
                { id: 9, displayText: "Format", columnName: "format", value: '', type: ColumnType.String },
                { id: 10, displayText: "Is Unique key", columnName: "is_unique_key", value: '', type: ColumnType.Boolean },
                { id: 11, displayText: "Field Classification", columnName: "field_classification_name", value: '', type: ColumnType.String },
                { id: 12, displayText: "Exclude From Load", columnName: "exclude_from_load", value: '', type: ColumnType.Boolean },
                { id: 13, displayText: "Custom Load Sql", columnName: "custom_load_sql", value: '', type: ColumnType.String },


            ],
            isShowFilter: false,
            export: {
                csv_setting: { encoding: "", header: false, separator: "" },
                filters: [],
                file_type: "",
                included_properties: {},
                is_desc: false,
                sort_by: ""
            },
            isLoading: false,
            Ids: [],
            selectedIds: { name: "", op: "", value: [] },
            filters:this.props.current_route.includes("/field/")?this.props.filters: [],
            isAllChecked: false,
            isExporting: false

        };

        this.service = new FieldsService();
        this.sortList = this.sortList.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.exportTo = this.exportTo.bind(this);
        this.clearExportModal = this.clearExportModal.bind(this);
    }

    applyFilter = (filter) => {
        this.setState({ filters: filter, currentPage: 1 }, () => {
            this.props.ChangeFilters(filter);
            this.props.ChangePage(1);
            this.loadData();
        });
    }

    clearFilter = () => {
        this.setState({ filters: [], currentPage: 1, isShowFilter: false, selectedIds: { name: "", op: "", value: [] } }, () => {
            this.props.ChangeFilters([]);
            this.props.ChangePage(1);
            this.loadData();
        });
    }

    componentDidMount() {
        this.loadData();
    }

    private setLoading(loading: boolean) {
        this.setState({ isLoading: loading });
    }

    private loadData() {
        this.setLoading(true);
        this.service.getFieldsList(this.state.currentPage, this.state.pageSize, this.state.sortBy, this.state.sortOrder, this.state.filters)
            .then((res: HttpResponse<FieldsListResponseModel>) => {
                this.setLoading(false);
                if (res && res.result) {

                    this.setState({
                        result: res.result,
                        currentPage: res.result.paging.current_page,
                        pageSize: res.result.paging.page_size
                    }, () => {

                    });
                }
            });

    }

    pageChange(page: number) {
        if (this.state.currentPage == page) return;
        this.setState(
            {
                currentPage: page,
                isAllChecked: false,
                selectedIds: { name: "", op: "", value: [] }
            },
            () => {
                this.props.ChangePage(page);
                this.loadData();
            }
        )
    }

    sortList(sortColumn: string, sortOrder: boolean) {
        this.currentColumn = sortColumn;
        this.setState(
            { sortBy: sortColumn, sortOrder: sortOrder, isAllChecked: false }, () => {
                this.loadData();
            }
        )
    }

    handleClose = () => {
        this.setState({ showExportModal: false }, () => {
        });
    }

    handleShow = () => {
        this.setState({ showExportModal: true }, () => {

        });
    }

    toggleFilter = () => {
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }

    private setIsExporting(exporting: boolean) {
        this.setState({ isExporting: exporting });
    }

    clearExportModal(data) {
        this.setState({
            isSelectedAll: data.isSelectedAll,
            isNoHeader: data.isNoHeader,
            columnSeparator: data.columnSeparator,
            encodeToName: data.encodeToName,
            exportTo: data.exportTo,
        })
    }

    export() {
        this.setIsExporting(true);
        this.service.exportFields(this.state.export)
            .then((res) => {
                this.setIsExporting(false);
                if (res) {
                    new FileDownloadService().downloadFileByStream(res, this.state.export?.exportFileName || 'inbouldFileslist.csv');
                    this.handleClose();
                }
            }, () => {
                this.setIsExporting(false);
                ShowErrorMessage();
            });
    }

    exportTo = data => {
        let filterdata = this.state.filters?.slice();
        if (this.state.selectedIds.value.length != 0) {
            filterdata?.push(this.state.selectedIds);
        }
        this.setState({
            export: {
                filters: filterdata,
                file_type: data.file_type.toLowerCase(),
                csv_setting: { encoding: data.csv_setting.encoding.toLowerCase(), header: !data.csv_setting.header, separator: data.csv_setting.separator.toLowerCase() },
                included_properties: data.included_properties,
                exportFileName: data.exportFileName,
                is_desc: this.state.sortOrder,
                sort_by: this.state.sortBy
            },
            isSelectedAll: data.isSelectedAll
        }, () => {
            // this.export();
        });
    }

    onSelectionChange(e: any) {
        // current array of ids
        let ids = this.state.Ids
        if (e.target.name === "all") {
            ids = []
            if (e.target.checked) {
                this.state.result.records.forEach(p => { p.isChecked = true })
                this.setState({ result: this.state.result, isAllChecked: true, Ids: ids }, () => {
                    this.state.result.records.forEach((p) => { ids.push(p.id) })
                })
            }
            else {
                this.state.result.records.forEach(p => { p.isChecked = false })
                this.setState({ result: this.state.result, isAllChecked: false, Ids: ids })
            }
        }
        else {
            let isAll;
            let index
            let checkedIndex = this.state.result.records.findIndex(p => p.id == e.target.value);
            this.state.result.records[checkedIndex]["isChecked"] = e.target.checked;
            if (e.target.checked) {
                ids.push(+e.target.value)
                if (this.state.result.records.filter(p => p.isChecked == true).length === this.state.result.records.length) {
                    isAll = true;
                }
            } else {
                // remove the value from the unchecked checkbox from the array
                index = ids.indexOf(+e.target.value)
                ids.splice(index, 1)
                isAll = false;
            }
            this.setState({ result: this.state.result, isAllChecked: isAll })
        }
        // update the state with the new array of ids
        let selectedIds = { name: "id", op: "in", value: ids }
        this.setState({ selectedIds: selectedIds })
    }
    render() {
        return (
            <Fragment>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="flex-fill">
                        <div className="row">
                            <div className="col-md-8"> <h4>List of Fields</h4></div>
                            <div className="col-md-4 text-right">
                                 {/* <button type="button" className="btn btn-secondary ml-3" onClick={this.handleShow}><i className="fas fa-download"></i> {ButtonType.Export}</button> */}
                                <button type="button" className="btn btn-primary ml-3" onClick={this.toggleFilter}><i className="fas fa-filter"></i> {ButtonType.AddFilter}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal backdrop='static' keyboard={false} size="lg" show={this.state.showExportModal} onHide={this.handleClose}>
                    <ExportComponent isSelectedAll={this.state.isSelectedAll} isNoHeader={this.state.isNoHeader} columnList={this.columnList} handleClose={this.handleClose} exportTo={this.exportTo} isExporting={this.state.isExporting} fileNamePrefix='account_list_' clearExportModal={this.clearExportModal} />
                </Modal>
                <div className="d-flex">
                    <div className="flex-fill">
                        <div className="card">
                            <div>
                                <div className="card-body p-0">
                                    <div className="sticky-table-wrapper" >
                                        <StickyTable borderWidth={0} rightStickyColumnCount={1} wrapperRef={Wrapper}>
                                            <Row className="sticky-table-header">
                                                <Cell className=" text-center">
                                                    <div className="custom-checkbox custom-control">
                                                        <input type="checkbox" className="custom-control-input"
                                                            value="all" onChange={this.onSelectionChange.bind(this)} id="all" name="all" checked={this.state.isAllChecked} />
                                                        <label htmlFor="all" className="custom-control-label">&nbsp;</label>
                                                    </div>

                                                </Cell>
                                                <Sorting columnName="id" displayName="Id" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Sorting columnName="scope_name" displayName="Scope" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Sorting columnName="name" displayName="Name" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Sorting columnName="label" displayName="Label" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Sorting columnName="type" displayName="Type" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Sorting columnName="column_type" displayName="Column Type" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Sorting columnName="options" displayName="Options" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Sorting columnName="scaling_factor" displayName="Scaling Factor" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Sorting columnName="format" displayName="Format" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Sorting columnName="is_unique_key" displayName="Is Unique key" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Sorting columnName="field_classification_name" displayName="Field Classification" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Sorting columnName="exclude_from_load" displayName="Exclude From Load" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Sorting columnName="custom_load_sql" displayName="Custom Load Sql" currentColumn={this.currentColumn} sortOrder={this.state.sortOrder} onClick={this.sortList} />
                                                <Cell>Report Column</Cell>
                                                <Cell>Schema</Cell>
                                                <Cell>Report Template Columns</Cell>
                                                <Cell>Report Templates</Cell>
                                                <Cell>Data Source Fields</Cell>
                                                <Cell>Report Column Fields</Cell>
                                                <Cell>Dependent Report Columns</Cell>
                                                <Cell>Report Data Source Filters</Cell>
                                                <Cell>Scope Field Schema Changes</Cell>
                                                <Cell style={{ width: 50 }}>Action&nbsp;&nbsp;</Cell>
                                            </Row>
                                            {!this.state.isLoading && this.state.result.records.length > 0 && (
                                                this.state.result.records?.map((item: FieldsListModel) => {
                                                    let schemaTitle = item.schema_.name+" "+  item.schema_.id+ " "+item.schema_.schema_owner.text;
                                                    return (
                                                        <Row key={item.id}>
                                                            <Cell className="text-center">
                                                                <div className="custom-checkbox custom-control">
                                                                    <input type="checkbox" className="custom-control-input"
                                                                        value={item.id || ''} checked={item.isChecked || false} onChange={this.onSelectionChange.bind(this)} id={"checkbox" + item.id} name={"checkbox" + item.id} />
                                                                    <label htmlFor={"checkbox" + item.id} className="custom-control-label">&nbsp;</label>
                                                                </div>
                                                            </Cell>
                                                            <Cell title={item.id.toString()}>{item.id}</Cell>
                                                            {item.scope &&<Cell title={item.scope.text}><Link to={"/scope/detail/" + item.scope.value}>{item.scope.text}</Link></Cell>}
                                                            {!item.scope &&<Cell></Cell>}
                                                            <Cell title={item.name}><span className="sortlength">{item.name}</span></Cell>
                                                            <Cell title={item.label}><span className="sortlength">{item.label}</span></Cell>
                                                            <Cell title={item.type}><span className="sortlength">{item.type}</span></Cell>
                                                            <Cell title={item.column_type}><span className="sortlength">{item.column_type}</span></Cell>
                                                            <Cell title={item.options}><span className="sortlength">{item.options}</span></Cell>
                                                            <Cell title={item.scaling_factor}><span className="sortlength">{item.scaling_factor}</span></Cell>
                                                            <Cell title={!item.format?"-":item.format}>{!item.format?"-":item.format}</Cell>
                                                            <Cell>{item.is_unique_key &&  <i className="fas fa-check text-success text1" title="&#x2713;" ></i>}
                                                            {!item.is_unique_key && <i className="fas fa-times text-danger text1" title="&#x2718;"></i>} </Cell>
                                                            {item.field_classification &&<Cell title={item.field_classification.value.toString()}><Link to={"/field-classification/detail/" + item.field_classification.value}><span className="sortlength">{item.field_classification.text}</span></Link></Cell>}
                                                            {!item.field_classification &&<Cell></Cell>}
                                                            <Cell>{item.exclude_from_load &&  <i className="fas fa-check text-success text1" title="&#x2713;" ></i>}
                                                            {!item.exclude_from_load && <i className="fas fa-times text-danger text1" title="&#x2718;"></i>} </Cell>
                                                            <Cell title={!item.custom_load_sql?"-":item.custom_load_sql}>{!item.custom_load_sql?"-":item.custom_load_sql}</Cell>
                                                            {item.report_column &&<Cell title={item.report_column.text}><Link to={"/report-column/detail/" + item.report_column.value}><span className="sortlength">{item.report_column.text}</span></Link></Cell>}
                                                            {!item.report_column &&<Cell></Cell>}

                                                            {item.schema_ &&<Cell title={schemaTitle}><Link to={"/schema/detail/" + item.schema_.id}><span title={schemaTitle} className="sortlength"> {schemaTitle}</span></Link></Cell>}
                                                            {!item.schema_ &&<Cell></Cell>}

                                                            {item.report_template_columns && <Cell>
                                                                <span className="sortlength">
                                                            {item.report_template_columns.map((item: DropdownModel, i, arr) => {
                                                                return (
                                                                    <span key={item.value}>
                                                                        {item && <a href="#">{item.text}{i != (arr.length-1) ? ', ' : ''}</a>}
                                                                    </span>
                                                                );
                                                            })}
                                                            </span>
                                                        </Cell>}
                                                        {!item.report_template_columns && <Cell></Cell>}

                                                        {item.report_templates && <Cell>
                                                                <span className="sortlength">
                                                            {item.report_templates.map((item: DropdownModel, i, arr) => {
                                                                return (
                                                                    <span key={item.value}>
                                                                        {item && <a href="#">{item.text}{i != (arr.length-1) ? ', ' : ''}</a>}
                                                                    </span>
                                                                );
                                                            })}
                                                            </span>
                                                        </Cell>}
                                                        {!item.report_templates && <Cell></Cell>}

                                                        {item.data_source_fields && <Cell>
                                                                <span className="sortlength">
                                                            {item.data_source_fields.map((item: DataSourceFieldsModel, i, arr) => {
                                                                return (
                                                                    <span key={i}>
                                                                        {item && <a href="#">{item.label}{i != (arr.length-1) ? ', ' : ''}</a>}
                                                                    </span>
                                                                );
                                                            })}
                                                            </span>
                                                        </Cell>}
                                                        {!item.data_source_fields && <Cell></Cell>}

                                                        {item.report_column_fields && <Cell>
                                                            <span className="sortlength">
                                                            {item.report_column_fields.map((feild: ReportColumnFieldModel, i, arr) => {
                                                                return (
                                                                    <span key={i}>
                                                                        {feild && <NavLink to={"/report-column-field/detail/" + feild.id}>{feild.type}{i != (arr.length-1) ? ', ' : ''}</NavLink>}
                                                                    </span>
                                                                );
                                                            })}
                                                            </span>
                                                        </Cell>}
                                                        {!item.report_column_fields && <Cell></Cell>}

                                                        {item.dependent_report_columns && <Cell>
                                                                <span className="sortlength">
                                                            {item.dependent_report_columns.map((item: DropdownModel, i, arr) => {
                                                                return (
                                                                    <span key={item.value}>
                                                                        {item && <a href="#">{item.text}{i != (arr.length-1) ? ', ' : ''}</a>}
                                                                    </span>
                                                                );
                                                            })}
                                                            </span>
                                                        </Cell>}
                                                        {!item.dependent_report_columns && <Cell></Cell>}

                                                        {item.report_data_source_filters && <Cell>
                                                            <span className="sortlength">
                                                            {item.report_data_source_filters.map((item: ReportDataSourceFilterModel, i, arr) => {
                                                                return (
                                                                    <span key={item.id}>
                                                                         <span>ReportDataSourceFilters #{item.id}{i != (arr.length-1) ? ', ' : ''}</span>
                                                                    </span>
                                                                );
                                                            })}
                                                            </span>
                                                        </Cell>}
                                                        {!item.report_data_source_filters && <Cell></Cell>}

                                                        {item.scope_field_schema_changes && <Cell>
                                                            <span className="sortlength">
                                                            {item.scope_field_schema_changes.map((item: ReportDataSourceFilterModel, i, arr) => {
                                                                return (
                                                                    <span key={item.id}>
                                                                         <span>ScopeFieldSchemaChanges #{item.id}{i != (arr.length-1) ? ', ' : ''}</span>
                                                                    </span>
                                                                );
                                                            })}
                                                            </span>
                                                        </Cell>}
                                                        {!item.scope_field_schema_changes && <Cell></Cell>}

                                                            <Cell>
                                                            {IsAuthorize([Role.TAM, Role.Dev, Role.AM, Role.Support, Role.Admin, Role.SuperAdmin]) && <Link to={"/field/field-form/" + item.id+"/"+item.schema_.name+"/"+item.scope.value} className="far fa-edit  m-2" title="Edit"></Link>}
                                                            <Link to={"/field/detail/" + item.id+"/"+item.schema_.name+"/"+item.scope.value} className="fas fa-info-circle m-2" title="Show"></Link>
                                                            {(item.schema_.name== SourceType.CONNECTION.toLocaleLowerCase() ||item.schema_.name== SourceType.CUSTOM_CONNECTION.toLocaleLowerCase())  && IsAuthorize([Role.TAM, Role.Dev, Role.AdminViewer]) && <Link to={"/field/schema-manager/" + item.id+"/"+item.schema_.name+"/"+item.scope.value} className="fas fa-check mr-2" title="Schema Manager"></Link>}
                                                            </Cell>
                                                        </Row>
                                                    );
                                                })
                                            )}
                                        </StickyTable>
                                        {!this.state.isLoading && this.state.result.records.length === 0 && <div className="text-danger text-center"> <img src="../../no-data.jpg" className="img-fluid" alt="No Data Found" /></div>}
                                        {this.state.isLoading && <Loader loading={this.state.isLoading} />}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="d-flex justify-content-between">
                                <PaginationRecordInfo currentPage={this.state.currentPage} totalRecords={this.state.result?.paging.total_items} pageSize={this.state.pageSize} />
                                <Pagination currentPage={this.state.currentPage} pageCount={this.state.result?.paging.page_count} onChangePage={this.pageChange} />
                            </div>
                        </div>
                    </div>
                    {this.state.isShowFilter &&
                        <div className="page-filter">
                            <div className="d-flex justify-content-between">
                                <h6>Filter by</h6>
                                {/* <div onClick={this.toggleFilter}>
                                    <i className="fa fa-times"></i>
                                </div> */}
                                <button className="btn btn-default btn-sm" onClick={this.toggleFilter}> <i className="fa fa-times"></i></button>
                            </div>
                            <hr />
                            <Filter columnList={this.state.Columns} applyFilter={this.applyFilter} clearFilter={this.clearFilter} />
                        </div>
                    }
                </div>
            </Fragment>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FieldsList);